module.exports = __webpack_public_path__ + "static/media/wait.38158bf9.svg";